module.exports = __webpack_public_path__ + "img/team.60eaae54.png";